import { useEffect, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Tokenomics = () => {
    const Highchart = useRef(null);
    const patterns = useRef(null);

    useEffect(() => {
        const Highcharts = require('highcharts');
        const addFunnel = require('highcharts/modules/funnel');
        const addAccess = require('highcharts/modules/accessibility');
        const addPattern = require('highcharts/modules/pattern-fill');
        addFunnel(Highcharts);
        addAccess(Highcharts);
        addPattern(Highcharts);
        
        let clrs = Highcharts.getOptions().colors;
        
        let pieColors = [clrs[2], clrs[0], clrs[3], clrs[5], clrs[1], clrs[4], clrs[6]];
        
        const getPattern = (i) => {
            return {
                pattern: Highcharts.merge(Highcharts.patterns[i], {
                    color: pieColors[i]
                })
            };
        }
        patterns.current = ([0, 1, 2, 3, 4, 5, 6].map(getPattern));

        Highchart.current = (Highcharts);
    }, [])

    useEffect(() => {
        AOS.init({ duration: 2000 });
        
    }, []);

    useEffect(() => {
        if (!Highchart) return;

        Highchart.current.chart('container', {
            chart: {
                type: 'pie'
            },

            title: {
                text: ''
            },

            subtitle: {
                text: ''
            },

            colors: patterns.current,

            tooltip: {
                valueSuffix: '%',
                borderColor: '#8ae'
            },

            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        connectorColor: '#777',
                        format: '<b>{point.name}</b>: {point.y:.1f} %'
                    },
                    borderWidth: 2
                }
            },

            series: [{
                name: 'Distribution',
                data: [{
                    name: 'Founders/Team',
                    y: 16
                }, {
                    name: 'Treasury',
                    y: 9.5
                }, {
                    name: 'Presale',
                    y: 25
                }, {
                    name: 'Public',
                    y: 15
                }, {
                    name: 'Strategic Partnerships',
                    y: 6
                }, {
                    name: 'Advisors & Marketing',
                    y: 8.5
                }, {
                    name: 'Community & Ecosystem',
                    y: 20
                }]
            }],

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        plotOptions: {
                            series: {
                                dataLabels: {
                                    format: '<b>{point.name}</b>'
                                }
                            }
                        }
                    }
                }]
            }
        })
    }, [Highchart])

    return (
        <section className="Tokenomics" id="Tokenomics">
            <h2>Tokenomics</h2>
            <div className='hcharts' data-aos="zoom-in-down">
                <figure className="highcharts-figure">
                    <div id="container"></div>
                </figure>
            </div>

            <div className='tokenomics__table' data-aos="fade-up">
                <table>
                    <tr>
                        <th>Token Distribution</th>
                        <th>Percentage</th>
                        <th>Distribution Schedule</th>
                    </tr>
                    <tr>
                        <td>Founders/Team</td>
                        <td>16%</td>
                        <td>Lockup over 2 years, then 10% monthly unlock</td>
                    </tr>
                    
                    <tr>
                        <td>Treasury</td>
                        <td>9.5%</td>
                        <td>6 months lock, linear unlock over 12 months</td>
                    </tr>
                    
                    <tr>
                        <td>Presale</td>
                        <td>25%</td>
                        <td>8 Months vesting, Linear release schedule</td>
                    </tr>
                    
                    <tr>
                        <td>Public</td>
                        <td>15%</td>
                        <td>Full Unlock at TGE</td>
                    </tr>
                    
                    <tr>
                        <td>Strategic Partnerships</td>
                        <td>6%</td>
                        <td>12 months, linear release schedule</td>
                    </tr>
                    
                    <tr>
                        <td>Advisors & Marketing</td>
                        <td>8.5%</td>
                        <td>12 months lock, linear unlock over 12 months </td>
                    </tr>
                    
                    <tr>
                        <td>Community & Ecosystem</td>
                        <td>20%</td>
                        <td>6 months lock, linear unlock over 36 months</td>
                    </tr>
                </table>
            </div>
        </section>
    )
}

export default Tokenomics;